import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs";
import { HTTPService } from "../../../../app/service/http.service";
import { TypeSystem } from "../../../../app/support/type-system.support";
import { HTTPMethod } from "../../../../app/model/http-method.enum";
import { map } from "rxjs/operators";
import { HTTPRequestBuilder } from "../../../../app/model/http.request.model";

@Injectable({
  providedIn: "root"
})
export class TransportService {
  private API_TRANSPORT_URL = environment.API_URL + "api/Transport";
  private API_TRANSPORT_FIND_URL = environment.API_URL + "api/Transport";

  constructor(private http: HttpClient, private httpService: HTTPService) { }

  public basePath(): string {
    return "api/Transport";
  }

  getAll() {
    return this.http.get(this.API_TRANSPORT_URL);
  }

  getItem(id: any) {
    return this.http.get(`${this.API_TRANSPORT_FIND_URL}/${id}`);
  }

  createItem(value: any) {
    return this.http.post(this.API_TRANSPORT_FIND_URL, value);
  }

  updateItem(value: any, id: number) {
    value.id = id;
    return this.http.put(`${this.API_TRANSPORT_FIND_URL}/${id}`, value);
  }

  public undoReturn(orderId: number): Observable<typeof TypeSystem.EmptyObject> {
    return this.httpService.send<typeof undefined, typeof TypeSystem.EmptyObject>(
      new HTTPRequestBuilder()
        .method(HTTPMethod.POST)
        .controllerPath(this.basePath())
        .relativePath(`undoReturns?orderId=${orderId}`)
        .build())
      .pipe(map(() => TypeSystem.EmptyObject));
  }
}
